import { z } from "@msuite/utils/lib/zod";
import { defineMutator } from "@rocicorp/zero";
import { Guards } from "../handlers/guards.handlers";

export const crewMutators = {
	delete: defineMutator(z.object({ crewId: z.uuid() }), async ({ args, tx, ctx }) => {
		await Guards.assertCrewInOrg(tx, ctx, args.crewId);
		return await tx.mutate.crews?.delete({ id: args.crewId });
	}),
};
